import { get } from '../index';
import {ApiResponse, UserProperty} from '../../types';


export async function UserDetail() {
    const response = await get<ApiResponse<UserProperty>>('/users/detail');
    return response.data;
}
